export default __webpack_public_path__ + "static/media/Powered-by-Sorted.656f1ebb.svg";